import { useTranslation } from 'react-i18next'

const Store = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="store-title"
      {...props}
    >
      <title id="store-title">{t('antagonists:grownup:components:background')}</title>
      <defs>
        <clipPath id="store-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="store-c">
          <path
            d="M238.07 154.67c-1.29 13.31-11.23 22.28-12.24 47.46-1.29 32.24-1.7 77.73-1.7 77.73l44.85 1.09s.3-46.75-1.34-76.99c-1.32-24.37-11.49-31.39-13.96-47.94-1.96-13.18-2.87-25.68-2.87-25.68l-10.67.57s-.82 10.84-2.07 23.76Z"
            style={{
              fill: '#ed774c',
            }}
          />
        </clipPath>
        <clipPath id="store-d">
          <path
            d="M288.05 155.28c-1.29 13.31-11.23 22.28-12.24 47.46-1.29 32.24-2.12 77.73-2.12 77.73l44.85 1.09s.72-46.75-.92-76.99c-1.32-24.37-11.49-31.39-13.96-47.94-1.96-13.18-2.87-25.68-2.87-25.68l-10.67.57s-.82 10.84-2.07 23.76Z"
            style={{
              fill: '#a44053',
            }}
          />
        </clipPath>
        <clipPath id="store-e">
          <path
            d="M372.45 148.14c-1.3 13.43-11.33 22.47-12.34 47.86-1.3 32.51-2.14 78.39-2.14 78.39l45.23 1.09s.72-47.14-.93-77.65c-1.33-24.58-11.59-31.65-14.07-48.34-1.98-13.29-2.9-25.9-2.9-25.9l-10.76.58s-.83 10.94-2.09 23.96Z"
            style={{
              fill: '#847052',
            }}
          />
        </clipPath>
        <clipPath id="store-f">
          <path
            style={{
              fill: '#00658d',
            }}
            d="m1637.39 453.31-.42-115.59-151.6-.41v115.17l152.02.83z"
          />
        </clipPath>
        <clipPath id="store-g">
          <path
            style={{
              fill: '#f0f4f8',
            }}
            d="M-330.3 377.73H920.55v733.79H-330.3z"
          />
        </clipPath>
        <clipPath id="store-h">
          <path
            style={{
              fill: '#deb4d2',
            }}
            d="m381.96 337.42 19 41.51h96.79l20.81-40.96-136.6-.55z"
          />
        </clipPath>
        <clipPath id="store-i">
          <path
            d="M274.13 486.01s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
            style={{
              fill: '#f6bcc8',
            }}
          />
        </clipPath>
        <clipPath id="store-j">
          <path
            d="M214.47 487.09s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
            style={{
              fill: '#f6bcc8',
            }}
          />
        </clipPath>
        <clipPath id="store-k">
          <path
            d="M339.22 487.85s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
            style={{
              fill: '#fabd43',
            }}
          />
        </clipPath>
        <clipPath id="store-l">
          <path
            d="M391.73 486.93s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
            style={{
              fill: '#fabd43',
            }}
          />
        </clipPath>
        <clipPath id="store-m">
          <path
            d="M439.64 486.01s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
            style={{
              fill: '#fabd43',
            }}
          />
        </clipPath>
        <clipPath id="store-n">
          <path
            style={{
              fill: '#fdd900',
            }}
            d="m1303.75 92.96.79 138.91 104.87-.42.78-140.15-106.44 1.66z"
          />
        </clipPath>
        <clipPath id="store-o">
          <path
            style={{
              fill: '#c59bc1',
            }}
            d="m1446.28 92.45.78 138.92 104.88-.42.78-140.16-106.44 1.66z"
          />
        </clipPath>
        <style>
          {
            '.q{fill:none}.r{fill:#f4a019}.s{fill:#f8b350}.t{fill:#f2f5f9}.u{fill:#fabd43}.v{fill:#00658d}.w{fill:#006443}.x{fill:#007581}.y{fill:#00814c}.aa{fill:#007bc2}.ab{fill:#eee5c6}.ac{fill:#f09393}.ad{fill:#ed774c}.ae{fill:#ed7a30}.af{fill:#eaba00}.ag{fill:#f6bcc8}.ah{fill:#fdd900}.ai{fill:#e95e2b}.aj{fill:#ef8227}.ak{fill:#e6418d}.al{fill:#e9b800}.am{fill:#f39843}.an{fill:#f0f4f8}.ao{fill:#ffd628}.ap{fill:#ffd500}.aq{fill:#fbf9f7}.ar{fill:#fbf8f6}.as{fill:#e8523b}.at{fill:#ee7f00}.au{fill:#fcf6e7}.av{fill:#6b9e6a}.aw{fill:#009e63}.ax{fill:#a0c443}.ay{fill:#a19a9e}.ba{fill:#aa8d42}.bb{fill:#aea7ab}.bc{fill:#d8abcc}.bd{fill:#a6cbce}.be{fill:#d9e3e9}.bf{fill:#deb4d2}.bg{fill:#c59bc1}.bh{fill:#d7007a}.bi{fill:#db9823}.bj{fill:#d55998}.bk{fill:#c695bf}.bl{fill:#e42625}.bm{fill:#ca332e}.bn{fill:#23a4a6}.bo{fill:#3fa25a}.bp{fill:#444851}.bq{fill:#a44053}.br{fill:#a40872}.bs{fill:#8a4967}.bt{fill:#554b51}.bu{fill:#352e50}.bv{fill:#5a5099}.bw{fill:#5a7a3e}.bx{fill:#847052}.by{fill:#4a9055}.ca{clip-path:url(#store-b)}.cb{clip-path:url(#store-f)}.cc{clip-path:url(#store-e)}.cd{clip-path:url(#store-d)}.ce{clip-path:url(#store-n)}.cf{clip-path:url(#store-m)}.cg{clip-path:url(#store-l)}.ch{clip-path:url(#store-k)}.ci{clip-path:url(#store-j)}.cj{clip-path:url(#store-i)}.ck{clip-path:url(#store-h)}.cl{clip-path:url(#store-g)}.cm{clip-path:url(#store-o)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#store-b)',
        }}
        id="store-a"
      >
        <path
          style={{
            fill: '#d9e3e9',
          }}
          d="M-245.49-150.32h2454.94v1353.69H-245.49z"
        />
        <path
          d="M238.07 154.67c-1.29 13.31-11.23 22.28-12.24 47.46-1.29 32.24-1.7 77.73-1.7 77.73l44.85 1.09s.3-46.75-1.34-76.99c-1.32-24.37-11.49-31.39-13.96-47.94-1.96-13.18-2.87-25.68-2.87-25.68l-10.67.57s-.82 10.84-2.07 23.76Z"
          style={{
            fill: '#ed774c',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-c)',
          }}
        >
          <path
            d="m214.82 201.43 68.41-2.12 3.84 49.79-82.86 2.71s11.14-50.38 10.61-50.38Z"
            style={{
              fill: '#d55998',
            }}
          />
        </g>
        <path
          d="m238.65 143.98.12-12.96a2.7 2.7 0 0 1 2.63-2.66l7.92-.2a2.704 2.704 0 0 1 2.77 2.64l.19 13.03-13.62.15Z"
          style={{
            fill: '#a40872',
          }}
        />
        <path
          d="M288.05 155.28c-1.29 13.31-11.23 22.28-12.24 47.46-1.29 32.24-2.12 77.73-2.12 77.73l44.85 1.09s.72-46.75-.92-76.99c-1.32-24.37-11.49-31.39-13.96-47.94-1.96-13.18-2.87-25.68-2.87-25.68l-10.67.57s-.82 10.84-2.07 23.76Z"
          style={{
            fill: '#a44053',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-d)',
          }}
        >
          <path
            d="m267.34 202.24 63.77-1.98 1.48 49.93-75.14-.99s10.38-46.96 9.89-46.96Z"
            style={{
              fill: '#8a4967',
            }}
          />
        </g>
        <path
          d="M372.45 148.14c-1.3 13.43-11.33 22.47-12.34 47.86-1.3 32.51-2.14 78.39-2.14 78.39l45.23 1.09s.72-47.14-.93-77.65c-1.33-24.58-11.59-31.65-14.07-48.34-1.98-13.29-2.9-25.9-2.9-25.9l-10.76.58s-.83 10.94-2.09 23.96Z"
          style={{
            fill: '#847052',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-e)',
          }}
        >
          <path
            d="m348.27 195.38 68.99-2.14 1.6 54.02-81.29-1.07s11.23-50.81 10.7-50.81Z"
            style={{
              fill: '#0090cb',
            }}
          />
        </g>
        <path
          d="m288.63 144.59.12-12.96a2.7 2.7 0 0 1 2.63-2.66l7.92-.2a2.704 2.704 0 0 1 2.77 2.64l.19 13.03-13.62.15Z"
          style={{
            fill: '#e9b800',
          }}
        />
        <path
          d="m373.03 132.4.12-13.07a2.72 2.72 0 0 1 2.65-2.68l7.99-.2a2.713 2.713 0 0 1 2.79 2.66l.19 13.15-13.74.15Z"
          style={{
            fill: '#ca332e',
          }}
        />
        <path
          style={{
            fill: '#f2f5f9',
          }}
          d="m-356.74 277 2495.78-.37 18.45 21.84-2532.22-.87 17.99-20.6z"
        />
        <path
          style={{
            fill: '#554b51',
          }}
          d="m1549.21 429.46.36 190.63 18.76-.89V433.75l-19.12-4.29z"
        />
        <path
          style={{
            fill: '#554b51',
          }}
          d="m1655.18 469.25-.5-147.37-184.23-.52v146.85l184.73 1.04z"
        />
        <path
          style={{
            fill: '#00658d',
          }}
          d="m1637.39 453.31-.42-115.59-151.6-.41v115.17l152.02.83z"
        />
        <g
          style={{
            clipPath: 'url(#store-f)',
          }}
        >
          <path
            style={{
              fill: '#007581',
            }}
            d="M1560.84 405.88v29.02l-51.52 1.01-.37-30.36 51.89.33z"
          />
          <path
            style={{
              fill: '#5a5099',
            }}
            d="m1650.92 356.75 2.1 62.11-80.59.33.05-64.56 78.44 2.12z"
          />
        </g>
        <path
          style={{
            fill: '#554b51',
          }}
          d="m1411.31 483.16-1.26 102.93-18.76-.89.89-97.75 19.13-4.29z"
        />
        <path
          style={{
            fill: '#554b51',
          }}
          d="m1427.28 434.82 5.15 18.64-37.08 52.35-25.57-1.19-6.15-11.9 34.3-57.9h29.35z"
        />
        <path
          style={{
            fill: '#fcf6e7',
          }}
          d="m1408.24 455.05-7.33 13.08-20.23-.39 8.33-13.88 19.23 1.19z"
        />
        <path
          style={{
            fill: '#e42625',
          }}
          d="m1389.74 490.47-1.54 3.36h-5.52l1.41-3.97 5.65.61z"
        />
        <path
          style={{
            fill: '#ffd628',
          }}
          d="m1381.61 490.26-2.16 3.97-5.11-.27 1.55-4.1 5.72.4z"
        />
        <path
          style={{
            fill: '#3fa25a',
          }}
          d="m1373.54 489.79-1.95 3.7-4.44-1.68.8-2.42 5.59.4z"
        />
        <path
          style={{
            fill: '#352e50',
          }}
          d="m1397.14 474.93-1.55 2.69-4.97-.2 1.14-2.82 5.38.33zM1389.47 474.46l-1.54 2.69-4.98-.2 1.14-2.82 5.38.33zM1381.47 474.26l-1.55 2.69-4.97-.2 1.14-2.83 5.38.34zM1378.71 479.5l-1.54 2.69-4.98-.2 1.14-2.82 5.38.33zM1376.39 484.75l-1.55 2.69-4.98-.21 1.15-2.82 5.38.34zM1394.72 480.11l-1.55 2.69-4.97-.2 1.14-2.83 5.38.34zM1391.96 485.76l-1.55 2.69-4.97-.2 1.14-2.83 5.38.34zM1386.45 479.91l-1.55 2.69-4.98-.2 1.15-2.83 5.38.34zM1383.69 485.56l-1.55 2.69-4.97-.2 1.14-2.83 5.38.34z"
        />
        <path
          style={{
            fill: '#a19a9e',
          }}
          d="m1424.3 473.69-4.16-8.73-16.66 20.23 4.76 10.31 5.16-6.94-1.39-3.77 6.35-7.53 1.38 2.97 4.56-6.54z"
        />
        <path
          style={{
            fill: '#f0f4f8',
          }}
          d="m594.73 562.26 1607.82-6.53 10.88 472.44-1625.23-15.24 6.53-450.67z"
        />
        <path
          style={{
            fill: '#23a4a6',
          }}
          d="m824.62 586.42 1556.82-6.53 10.89 472.44-1574.25-15.24 6.54-450.67z"
        />
        <path
          style={{
            fill: '#009e63',
          }}
          d="m807.72 808.29 1556.83-6.53 10.88 472.44-1574.24-15.24 6.53-450.67z"
        />
        <path
          style={{
            fill: '#f0f4f8',
          }}
          d="M-330.3 377.73H920.55v733.79H-330.3z"
        />
        <g
          style={{
            clipPath: 'url(#store-g)',
          }}
        >
          <path
            style={{
              fill: '#a6cbce',
            }}
            d="M543.69 403.76h352.59v733.79H543.69zM159.93 404.72h352.59v733.79H159.93z"
          />
          <path
            style={{
              fill: '#f2f5f9',
            }}
            d="M-50.02 505.87H910.8v18.66H-50.02z"
          />
          <path
            style={{
              fill: '#f0f4f8',
            }}
            d="M-481.11 739.47H929.25v262.97H-481.11z"
          />
        </g>
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#eee5c6',
          }}
          d="M-345.84 876.74h2661.47v733.79H-345.84z"
        />
        <path
          d="M784.19 683.62c-7.24 1.26-25.28 13.49-21.97 31.11 3.33 17.65 14.28 25.11 29.43 23.61 13.62-1.31 34.18-14.74 29.12-34.46-5.07-19.75-25.71-22.2-36.58-20.26"
          style={{
            fill: '#ef8227',
          }}
        />
        <path
          style={{
            fill: '#00814c',
          }}
          d="m789.98 686.35-1.61 3.48.65 2.77h-3.6l-3.61 1.02.09-2.96-1.2-2.4 2.68-.55 1.94-2.13 1.39 1.29 3.27-.52"
        />
        <path
          d="M708.01 637.38c-6.95-2.39-28.65-.41-34.27 16.62-5.61 17.06.37 28.88 14.35 34.89 12.55 5.43 37.04 3.61 42.15-16.09 5.1-19.74-11.78-31.87-22.23-35.42"
          style={{
            fill: '#ffd500',
          }}
        />
        <path
          style={{
            fill: '#00814c',
          }}
          d="m711.77 642.57-3.09 2.27-.77 2.74-3.16-1.74-3.65-.86 1.51-2.54.11-2.68 2.62.81 2.72-.93.59 1.8 3.12 1.13"
        />
        <path
          d="M745.71 686.15c-6.16-4.01-27.7-7.34-37.28 7.82-9.58 15.19-6.64 28.11 5.47 37.33 10.86 8.31 35.06 12.48 44.79-5.4 9.73-17.92-3.71-33.77-12.99-39.75"
          style={{
            fill: '#ffd500',
          }}
        />
        <path
          style={{
            fill: '#00814c',
          }}
          d="m750.35 691.64-3.55 1.46-1.42 2.47-2.64-2.45-3.33-1.71 2.08-2.11.76-2.57 2.34 1.42 2.86-.25.14 1.9 2.76 1.84"
        />
        <path
          d="M679.84 686.05c-6.16-4.01-27.7-7.34-37.28 7.82-9.58 15.19-6.64 28.11 5.47 37.33 10.86 8.31 35.06 12.48 44.79-5.4 9.73-17.92-3.71-33.77-12.99-39.75"
          style={{
            fill: '#ffd500',
          }}
        />
        <path
          style={{
            fill: '#00814c',
          }}
          d="m682.23 691.99-3.56 1.46-1.41 2.47-2.64-2.45-3.33-1.71 2.08-2.11.76-2.57 2.34 1.42 2.86-.25.14 1.9 2.76 1.84"
        />
        <path
          d="M601.74 686.51c-6.16-4.01-27.7-7.34-37.28 7.82-9.58 15.19-6.64 28.11 5.47 37.33 10.86 8.31 35.06 12.48 44.79-5.4 9.73-17.92-3.71-33.77-12.99-39.75"
          style={{
            fill: '#f39843',
          }}
        />
        <path
          style={{
            fill: '#00814c',
          }}
          d="m604.13 692.45-3.55 1.46-1.42 2.47-2.64-2.45-3.33-1.71 2.08-2.11.76-2.57 2.34 1.41 2.86-.24.14 1.9 2.76 1.84"
        />
        <path
          d="M617.85 658.18c5.1-3.31 22.91-6.07 30.84 6.47 7.92 12.57 5.49 23.25-4.53 30.88-8.99 6.88-29 10.32-37.05-4.47-8.05-14.82 3.07-27.94 10.75-32.88"
          style={{
            fill: '#ed7a30',
          }}
        />
        <path
          style={{
            fill: '#006443',
          }}
          d="m615.87 663.09 2.94 1.21 1.17 2.04 2.18-2.03 2.76-1.41-1.72-1.74-.63-2.14-1.93 1.18-2.37-.2-.12 1.57-2.28 1.52"
        />
        <path
          d="M576.38 467.5s1.95-6.47 1.32-11.62c-.81-6.77-3.68-10.09-3.68-10.09l-3.44 2.9s4.17 2.47 4.95 7.74c.66 4.45-1.69 9.99-1.69 9.99l-1.45 3.98 3.98-2.9Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          d="M575.64 461.67c-5.32-.59-14.36-5.11-20.6 1.17-6.23 6.26-5.86 32.09 9.47 41.48 4.32 2.64 7.91-.51 10.99-.46 4.02.07 5.64 3.03 10.98 1.34 11.98-3.79 18.73-32.97 11.18-41.11-7.21-7.77-14.95-1.64-22.03-2.42"
          style={{
            fill: '#e95e2b',
          }}
        />
        <path
          d="M662.7 467.39s1.95-6.47 1.32-11.62c-.81-6.77-3.68-10.09-3.68-10.09l-3.44 2.9s4.17 2.47 4.95 7.74c.66 4.45-1.69 9.99-1.69 9.99l-1.45 3.98 3.98-2.9Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          d="M661.95 461.55c-5.32-.59-14.36-5.11-20.6 1.17-6.23 6.26-5.86 32.09 9.47 41.48 4.32 2.64 7.91-.51 10.99-.46 4.02.07 5.64 3.03 10.98 1.34 11.98-3.79 18.73-32.97 11.18-41.11-7.21-7.77-14.95-1.64-22.03-2.42"
          style={{
            fill: '#4a9055',
          }}
        />
        <path
          d="M610.38 439.32s-4.98-4.56-7.07-9.31c-2.76-6.24-2-10.56-2-10.56l4.43.73s-2.32 4.25-.3 9.18c1.71 4.16 6.56 7.73 6.56 7.73l3.28 2.68-4.9-.46Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          d="M608.04 433.92c4.27-3.22 9.73-11.73 18.3-9.51 8.56 2.19 21.43 24.6 13.04 40.5-2.36 4.48-7.06 3.6-9.68 5.21-3.42 2.12-3.3 5.49-8.76 6.77-12.24 2.86-32.95-18.78-30.61-29.63 2.23-10.36 12.02-9.05 17.7-13.33"
          style={{
            fill: '#8cbb15',
          }}
        />
        <path
          d="M460.04 327.62c4.65 3.89 6.25 13.89-.7 17.93-7.95 4.63-19.46 7.32-28.5-.63-8.52-7.5-1.39-16.55 5.56-18.95 6.95-2.4 18.94-2.27 23.63 1.65"
          style={{
            fill: '#f4a019',
          }}
        />
        <path
          d="M512.78 331.48c1.83 8.5-5.19 21.22-16.61 19.65-13.07-1.78-28.46-8.89-31.66-25.84-3.01-15.99 13.03-19.93 23-16.52 9.97 3.42 23.42 14.14 25.26 22.71"
          style={{
            fill: '#f8b350',
          }}
        />
        <path
          d="M430 318.8c5.3 2.95 8.73 12.49 2.65 17.75-6.95 6.03-17.76 10.82-28.12 4.69-9.76-5.79-4.44-16 1.94-19.65 6.38-3.65 18.19-5.76 23.53-2.78"
          style={{
            fill: '#db9823',
          }}
        />
        <path
          style={{
            fill: '#deb4d2',
          }}
          d="m381.96 337.42 19 41.51h96.79l20.81-40.96-136.6-.55z"
        />
        <g
          style={{
            clipPath: 'url(#store-h)',
          }}
        >
          <path
            style={{
              fill: '#c695bf',
            }}
            d="m377.69 348.91 146.35.66 3.17-41.99-155.22-1.33 5.7 42.66z"
          />
        </g>
        <path
          d="M274.13 486.01s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
          style={{
            fill: '#f6bcc8',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-i)',
          }}
        >
          <path
            style={{
              fill: '#d7007a',
            }}
            d="m265.32 465.09 65.52 2.75-6.61-32.48-63.31-7.71 4.4 37.44z"
          />
        </g>
        <path
          style={{
            fill: '#fcf6e7',
          }}
          d="m266.43 479.13 11.83 24.22 31.66.55 9.91-26.43-53.4 1.66z"
        />
        <path
          d="M298.02 443.38c2.36 1.86 3.07 5.48.44 8.5-2.63 3.02-6.42 2.33-8.69.03-1.98-2-2.92-5.36-.28-8.37 2.63-3.02 5.7-2.39 8.53-.16Z"
          style={{
            fill: '#ffd500',
          }}
        />
        <path
          d="M214.47 487.09s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
          style={{
            fill: '#f6bcc8',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-j)',
          }}
        >
          <path
            style={{
              fill: '#d7007a',
            }}
            d="m205.66 466.17 65.52 2.76-6.61-32.49-63.32-7.7 4.41 37.43z"
          />
        </g>
        <path
          style={{
            fill: '#fcf6e7',
          }}
          d="m206.76 480.21 11.84 24.23 31.65.55 9.92-26.43-53.41 1.65z"
        />
        <path
          d="M238.35 444.47c2.36 1.86 3.07 5.48.44 8.5-2.63 3.02-6.42 2.33-8.69.03-1.98-2-2.92-5.36-.28-8.37 2.63-3.02 5.7-2.39 8.53-.16Z"
          style={{
            fill: '#ffd500',
          }}
        />
        <path
          d="M339.22 487.85s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
          style={{
            fill: '#fabd43',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-k)',
          }}
        >
          <path
            style={{
              fill: '#ee7f00',
            }}
            d="m330.41 466.93 65.52 2.75-6.61-32.48-63.32-7.71 4.41 37.44z"
          />
        </g>
        <path
          style={{
            fill: '#fcf6e7',
          }}
          d="m331.51 480.97 11.84 24.22 31.66.55 9.91-26.42-53.41 1.65z"
        />
        <path
          d="M363.1 445.23c2.36 1.86 3.07 5.48.44 8.5-2.63 3.02-6.42 2.33-8.69.03-1.98-2-2.92-5.36-.28-8.37 2.63-3.02 5.7-2.39 8.53-.16Z"
          style={{
            fill: '#e8523b',
          }}
        />
        <path
          d="M391.73 486.93s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
          style={{
            fill: '#fabd43',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-l)',
          }}
        >
          <path
            style={{
              fill: '#fcf6e7',
            }}
            d="m383.84 467.69 65.44-4.17-9.99-31.61-63.78-.99 8.33 36.77z"
          />
        </g>
        <path
          style={{
            fill: '#5a5099',
          }}
          d="m384.03 480.05 11.84 24.22 31.65.55 9.91-26.42-53.4 1.65z"
        />
        <path
          d="M415.62 444.31c2.36 1.86 3.07 5.48.44 8.5-2.63 3.02-6.42 2.33-8.69.03-1.98-2-2.92-5.36-.28-8.37 2.63-3.02 5.7-2.39 8.53-.16Z"
          style={{
            fill: '#a40872',
          }}
        />
        <path
          d="M439.64 486.01s-2.75-16.52-1.65-22.57c1.1-6.06 6.61-13.21 18.72-14.31 12.11-1.1 23.87 4.33 24.22 12.11.55 12.11-2.75 29.18-2.75 29.18l-38.54-4.41Z"
          style={{
            fill: '#fabd43',
          }}
        />
        <g
          style={{
            clipPath: 'url(#store-m)',
          }}
        >
          <path
            style={{
              fill: '#ee7f00',
            }}
            d="m430.84 465.09 65.51 2.75-6.6-32.48-63.32-7.71 4.41 37.44z"
          />
        </g>
        <path
          style={{
            fill: '#5a5099',
          }}
          d="m431.94 479.13 11.84 24.22 31.65.55 9.91-26.43-53.4 1.66z"
        />
        <path
          d="M463.53 443.38c2.36 1.86 3.07 5.48.44 8.5-2.63 3.02-6.42 2.33-8.69.03-1.98-2-2.92-5.36-.28-8.37 2.63-3.02 5.7-2.39 8.53-.16Z"
          style={{
            fill: '#e8523b',
          }}
        />
        <path
          d="M215.38 721.06s-3.11-18.64-1.86-25.47c1.24-6.83 7.46-14.91 21.12-16.15 13.67-1.24 26.94 4.89 27.33 13.67.62 13.67-3.11 32.93-3.11 32.93l-43.49-4.97Z"
          style={{
            fill: '#fcf6e7',
          }}
        />
        <path
          style={{
            fill: '#f09393',
          }}
          d="m206.68 707.07 13.36 27.33 35.72.62 11.19-29.82-60.27 1.87z"
        />
        <path
          d="M242.33 672.96c2.66 2.1 3.47 6.18.49 9.59-2.97 3.41-7.24 2.63-9.81.04-2.23-2.26-3.29-6.04-.31-9.45 2.97-3.41 6.44-2.69 9.63-.18Z"
          style={{
            fill: '#007bc2',
          }}
        />
        <path
          d="M274.64 723.14s-3.11-18.64-1.86-25.47c1.24-6.83 7.46-14.91 21.12-16.15 13.67-1.24 26.94 4.89 27.33 13.67.62 13.67-3.11 32.93-3.11 32.93l-43.49-4.97Z"
          style={{
            fill: '#fcf6e7',
          }}
        />
        <path
          style={{
            fill: '#f09393',
          }}
          d="m265.94 709.15 13.36 27.33 35.72.62 11.19-29.82-60.27 1.87z"
        />
        <path
          d="M301.59 675.04c2.66 2.1 3.47 6.18.49 9.59-2.97 3.41-7.24 2.63-9.81.04-2.23-2.26-3.29-6.04-.31-9.45 2.97-3.41 6.44-2.69 9.63-.18Z"
          style={{
            fill: '#007bc2',
          }}
        />
        <path
          d="M333.9 722.1s-3.11-18.64-1.86-25.47c1.24-6.83 7.46-14.91 21.12-16.15 13.67-1.24 26.94 4.89 27.33 13.67.62 13.67-3.11 32.93-3.11 32.93l-43.49-4.97Z"
          style={{
            fill: '#fcf6e7',
          }}
        />
        <path
          style={{
            fill: '#aa8d42',
          }}
          d="m325.21 708.11 13.35 27.33 35.72.62 11.19-29.82-60.26 1.87z"
        />
        <path
          d="M360.85 674c2.66 2.1 3.47 6.18.49 9.59-2.97 3.41-7.24 2.63-9.81.04-2.23-2.26-3.29-6.04-.31-9.45 2.97-3.41 6.44-2.69 9.63-.18Z"
          style={{
            fill: '#e6418d',
          }}
        />
        <path
          d="M409.31 724.94s-3.11-18.64-1.86-25.47c1.24-6.83 7.46-14.91 21.12-16.15 13.67-1.24 26.94 4.89 27.33 13.67.62 13.67-3.11 32.93-3.11 32.93l-43.49-4.97Z"
          style={{
            fill: '#f09393',
          }}
        />
        <path
          style={{
            fill: '#aa8d42',
          }}
          d="m400.61 710.95 13.36 27.33 35.72.62 11.18-29.82-60.26 1.87z"
        />
        <path
          d="M436.25 676.84c2.66 2.1 3.47 6.18.49 9.59-2.97 3.41-7.24 2.63-9.81.04-2.23-2.26-3.29-6.04-.31-9.45 2.97-3.41 6.44-2.69 9.63-.18Z"
          style={{
            fill: '#e6418d',
          }}
        />
        <path
          style={{
            fill: '#fbf8f6',
          }}
          d="m1293.32 80.13 127.41.75v182.87l-124.59.23-2.82-183.85z"
        />
        <path
          style={{
            fill: '#fdd900',
          }}
          d="m1303.75 92.96.79 138.91 104.87-.42.78-140.15-106.44 1.66z"
        />
        <g
          style={{
            clipPath: 'url(#store-n)',
          }}
        >
          <path
            style={{
              fill: '#eaba00',
            }}
            d="m1414.09 43.59-72.19 241.84 125.22-25.26 10.32-214.77-63.35-1.81z"
          />
        </g>
        <path
          style={{
            fill: '#fbf8f6',
          }}
          d="m1435.85 79.62 127.41.75v182.88l-124.59.23-2.82-183.86z"
        />
        <path
          style={{
            fill: '#c59bc1',
          }}
          d="m1446.28 92.45.78 138.92 104.88-.42.78-140.16-106.44 1.66z"
        />
        <g
          style={{
            clipPath: 'url(#store-o)',
          }}
        >
          <path
            style={{
              fill: '#d8abcc',
            }}
            d="m1556.61 43.09-72.18 241.84 125.22-25.27 10.31-214.77-63.35-1.8z"
          />
        </g>
        <path
          style={{
            fill: '#aea7ab',
          }}
          d="m1072.83 560.82-19.09-100.85-73.38.34 22.6 100.61 69.87-.1z"
        />
        <path
          style={{
            fill: '#fbf9f7',
          }}
          d="m954.34 560.76 20.89-100.72 78.34-.75-21.01 101.63-78.22-.16z"
        />
        <path
          d="m998.1 504.1-1.1 5.92s3.75.16 3.12 3.07c-.5 2.3-3.85 2.42-3.85 2.42l-.63 2.66s5.2.9 6.65-4.32c1.35-4.87-2.7-5.78-2.7-5.78l.39-1.54 2.48.11.43-2.24-4.78-.29ZM1012.11 510.33c-.77-.19-1.28.19-1.51.72-.24.56-.22 1.27.48 1.53.71.26 1.51-.19 1.69-.79.17-.57.11-1.27-.65-1.46ZM1011.54 514.16c-.77-.19-1.28.19-1.51.72-.24.56-.22 1.27.48 1.53.71.26 1.51-.19 1.69-.79.17-.57.11-1.27-.65-1.46ZM1028.68 511.86c-.63 2.89-2.05 7.25-5.25 6.99-3.33-.27-3.3-3.8-2.54-7.32.76-3.52 1.75-6.95 5-6.65 3.68.34 3.42 4.09 2.79 6.98Zm-3.41-4.14c-1.15 0-1.68 2.9-1.9 3.95-.23 1.05-.82 4.07.42 4.19 1.11.1 1.79-2.19 2.24-4.26.49-2.25.5-3.88-.75-3.88Z"
          style={{
            fill: '#5a7a3e',
          }}
        />
        <path
          d="m1006.43 518.6-2.3-.21 2.7-7.07s-2.98.38-3.72-1.84c-.87-2.61.91-5.81 4.2-5.39 2.38.31 3.44 1.72 2.58 4.77-1.06 3.76-3.47 9.74-3.47 9.74Zm-.42-12.25c-.67.23-.92.93-.87 1.69s.88.99 1.53.76 1.08-.94.95-1.6-.67-1.17-1.61-.86ZM1016.75 519.03l-2.3-.21 2.7-7.07s-2.98.38-3.72-1.84c-.87-2.61.91-5.81 4.2-5.39 2.38.31 3.44 1.72 2.58 4.77-1.06 3.76-3.47 9.74-3.47 9.74Zm-.42-12.25c-.67.23-.92.93-.87 1.69s.88.99 1.53.76 1.08-.94.95-1.6-.67-1.17-1.61-.86Z"
          style={{
            fill: '#5a7a3e',
          }}
        />
        <path
          style={{
            fill: '#6b9e6a',
          }}
          d="m979.83 487.12 55.39.15-2.26 10.18-55.42-.57 2.29-9.76z"
        />
        <path
          style={{
            fill: '#a0c443',
          }}
          d="m983.22 474.68 55.39.15-2.26 10.18-55.41-.57 2.28-9.76z"
        />
      </g>
    </svg>
  )
}

export default Store
